export default __webpack_public_path__ + "static/media/matching_red.1b86581f.svg";